module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[96]95.c38f4ea.woff2";